// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1bggo","select":"styles_select__3dbT1","input":"styles_input__1VMYd"};